/* File: src/components/explanations/shredsListExplanation.ts */
export const shredsListExplanation = `
<div class="text-gray-300 text-lg mb-4">

    <hr class="border-b-1 border-gray-600 my-2">
  
    <h2 class="text-blue-400 text-xl font-bold mb-2">1. What is a Project ?</h2>
    <p class="text-gray-200 text-base mb-4">
      Creating a new project with ShredsAI kickstarts a complete development cycle from the ground up. ShredsAI automatically generates all essential components, including technical specifications, architecture, code, documentation, and more—ensuring a seamless and efficient project launch and maintenance </p>
    <h2 class="text-green-400 text-xl font-bold mb-2">2. What is a Single Service ?</h2>
    <p class="text-gray-200 text-base mb-4">
      This is for a single service or a small project that doesn’t require architecture diagrams, detailed technical specifications, or extensive documentation, ShredsAI lets you skip straight to code generation </p>
    <h2 class="text-red-400 text-xl font-bold mb-2">3. How To Chose ?</h2>
    <p class="text-gray-200 text-base">
      As long as your project requires more than one service, you should create a project.<br>
      <span class="chip">TIP</span> : If you are not sure, then you should create a project.
    </p>
  
</div>
`;